import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { toIntlLocale } from "@/lib/app-language";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(
  date: string | number | Date,
  locale = "de-DE",
  options: Intl.DateTimeFormatOptions = {
    dateStyle: "medium",
    timeStyle: "short",
  },
) {
  const d =
    typeof date === "string" || typeof date === "number"
      ? new Date(date)
      : date;
  const intlLocale =
    locale.length === 2 ? toIntlLocale(locale) : locale;
  return new Intl.DateTimeFormat(intlLocale, options).format(d);
}

export const statusColors: Record<string, string> = {
  // New status values
  request_created: "bg-gray-400 text-white",
  waiting_for_information: "bg-indigo-500 text-white",
  in_processing: "bg-yellow-500 text-white",
  offer_in_progress: "bg-orange-500 text-white",
  offer_available: "bg-purple-600 text-white",
  offer_sent: "bg-blue-500 text-white",
  offer_rejected: "bg-red-600 text-white",
  order_in_progress: "bg-amber-500 text-white",
  in_delivery: "bg-cyan-500 text-white",
  delivered: "bg-green-600 text-white",
  closed: "bg-gray-800 text-white",
  canceled: "bg-red-800 text-white",
  
  // Legacy status values (for backward compatibility)
  Created: "bg-gray-400 text-white",
  Shipped: "bg-blue-500 text-white",
  Delivered: "bg-green-600 text-white",
  Canceled: "bg-red-600 text-white",
};
